import { useEffect, useState } from "react";
import SearchBar from "../components/SearchBar";
import { useLocation } from "react-router-dom";
import WorkorderCards from "../components/WorkorderCards";

export default function SearchPage() {
  const [isCardListVisible, setIsCardListVisible] = useState<boolean>(false);

  let [keyword, setKeyword] = useState<string | null>(null);
  let [contentType, setContentType] = useState<string | null>(null);
  let [channelIds, setChannelIds] = useState<string | null>(null);

  const location = useLocation();

  useEffect(() => {
    if (location.state) {
      const parameters = JSON.parse(location.state);
      if (parameters !== null) {
        //search Page è stata aperta a seguito di una ricerca su Home Page
        handleSearchResponse(
          parameters.keyword,
          parameters.contentType,
          parameters.channelIds,
        );
      }
    }
  }, [location.state]);

  function handleSearchResponse(
    requestKeyword,
    requestContentType,
    channelIds,
  ) {
    setKeyword(requestKeyword);
    setContentType(requestContentType);
    setChannelIds(channelIds);
    setIsCardListVisible(true);
  }

  return (
    <>
      <SearchBar sourcePage="search" onSearch={handleSearchResponse} />

      {isCardListVisible && (
        <WorkorderCards
          contextPage="search"
          keyword={keyword}
          contentType={contentType}
          channelIds={channelIds}
        ></WorkorderCards>
      )}
    </>
  );
}
